(() => {
  'use strict';
  const instances = new Map();
  const watchers = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = matchMedia('(min-width: 900px)');
    const connection = navigator.connection;
    const conserve = connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
    if (reduced.matches || !desktop.matches || conserve) return;
    const lines = [...root.querySelectorAll('[data-step]')];
    const video = root.querySelector('video');
    const toggle = root.querySelector('[data-motion-toggle]');
    let visible = false, paused = false, target = 0, displayed = 0, raf = 0;
    root.classList.add('is-enhanced');
    function readProgress() {
      const rect = root.getBoundingClientRect();
      const header = document.querySelector('#header-group')?.getBoundingClientRect().height || 105;
      target = Math.min(1, Math.max(0, (header - rect.top) / Math.max(1, rect.height - innerHeight + header)));
    }
    function paint() {
      raf = 0;
      if (!visible || paused) return;
      displayed += (target - displayed) * .12;
      if (Math.abs(target - displayed) < .001) displayed = target;
      root.style.setProperty('--progress', displayed.toFixed(4));
      root.style.setProperty('--reveal', Math.min(1, .13 + displayed * 1.55).toFixed(3));
      root.style.setProperty('--environment', Math.max(.03, (displayed - .2) / .8).toFixed(3));
      const step = Math.min(lines.length - 1, Math.floor(displayed * lines.length));
      lines.forEach((line, i) => line.style.setProperty('--step-opacity', i === step ? '1' : '0'));
      if (video && Number.isFinite(video.duration) && !video.seeking) {
        const time = Math.min(video.duration - .08, displayed * video.duration);
        if (Math.abs(video.currentTime - time) > .15) video.currentTime = Math.max(0, time);
      }
      if (displayed !== target) raf = requestAnimationFrame(paint);
    }
    function update() { if (visible && !paused) { readProgress(); if (!raf) raf = requestAnimationFrame(paint); } }
    const observer = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      if (visible) {
        if (video && !video.dataset.loaded) {
          if (video.dataset.source) video.src = video.dataset.source;
          video.preload = 'metadata'; video.load(); video.dataset.loaded = 'true';
        }
        update();
      } else { cancelAnimationFrame(raf); raf = 0; video?.pause(); }
    }, {rootMargin: '100px'});
    observer.observe(root);
    if (toggle) {
      toggle.hidden = false;
      toggle.textContent = 'PAUSE MOTION';
      toggle.setAttribute('aria-pressed', 'false');
      toggle.addEventListener('click', toggleMotion);
    }
    function toggleMotion() {
        paused = !paused;
        toggle.textContent = paused ? 'RESUME MOTION' : 'PAUSE MOTION';
        toggle.setAttribute('aria-pressed', String(paused));
        if (paused) {cancelAnimationFrame(raf); raf = 0; video?.pause();} else update();
    }
    if (video) {
      video.addEventListener('loadedmetadata', update);
      video.addEventListener('seeked', update);
    }
    const destroy = () => {
      observer.disconnect(); cancelAnimationFrame(raf); video?.pause();
      root.classList.remove('is-enhanced'); root.removeAttribute('style');
      lines.forEach(line => line.style.removeProperty('--step-opacity'));
      removeEventListener('scroll', update); removeEventListener('resize', update);
      video?.removeEventListener('loadedmetadata', update);
      video?.removeEventListener('seeked', update);
      if (toggle) { toggle.hidden = true; toggle.removeEventListener('click', toggleMotion); }
      instances.delete(root);
    };
    addEventListener('scroll', update, {passive: true});
    addEventListener('resize', update, {passive: true});
    instances.set(root, destroy);
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-333-cinema]').forEach(root => {
      if (!watchers.has(root)) {
        const desktop = matchMedia('(min-width: 900px)');
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const preferenceChange = () => { instances.get(root)?.(); mount(root); };
        desktop.addEventListener('change', preferenceChange);
        reduced.addEventListener('change', preferenceChange);
        watchers.set(root, () => {
          desktop.removeEventListener('change', preferenceChange);
          reduced.removeEventListener('change', preferenceChange);
        });
      }
      mount(root);
    });
  }
  init();
  document.addEventListener('cart:updated', event => {
    const count = event.detail?.item_count;
    if (!Number.isInteger(count)) return;
    document.querySelectorAll('.t333-cart').forEach(link => {
      link.setAttribute('aria-label', `Cart, ${count} items`);
      const badge = link.querySelector('[data-cart-count]');
      if (badge) badge.textContent = String(count);
    });
  });
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-333-cinema]').forEach(root => {
      instances.get(root)?.(); watchers.get(root)?.(); watchers.delete(root);
    });
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.t333-header details[open]').forEach(details => {
      details.open = false; details.querySelector('summary')?.focus();
    });
  });
})();
